var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:'buttons-group ' +
  ' button-' + _vm.type +
  ' button-' + _vm.size +
  (_vm.round ? ' button-round' : '') +
  (_vm.bordered ? ' button-bordered' : '')},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.5.0@vue-loader/lib/template-compiler?{"id":"data-v-79d4cec8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.5.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/buttons/button-group.vue
// module id = null
// module chunks = 